// src/pages/Privacy.jsx
import React from "react";
import "./LegalPages.css";

const Privacy = () => {
  return (
    <div className="legal-page">
      <div className="legal-hero">
        <h1>Privacy Policy</h1>
        <p>
          NexterZone is designed to reduce public exposure of personal information
          while enabling safe, platform-managed trades.
        </p>
      </div>

      <div className="legal-grid">
        <section className="legal-card">
          <h2>What we collect</h2>
          <ul>
            <li>Account identifiers (such as user ID or email)</li>
            <li>Listing and trade data (item details, offers, workflow status)</li>
            <li>Optional preferences such as location for discovery and filtering</li>
          </ul>
        </section>

        <section className="legal-card">
          <h2>What we do not publish</h2>
          <ul>
            <li>Phone numbers, email addresses, or physical addresses in listings</li>
            <li>Direct contact details between buyers and sellers</li>
          </ul>
        </section>

        <section className="legal-card">
          <h2>How we use data</h2>
          <ul>
            <li>To operate trade workflows (review, verification, pickup, delivery)</li>
            <li>To prevent fraud, theft, and policy violations</li>
            <li>To maintain platform reliability, safety, and performance</li>
          </ul>
        </section>

        <section className="legal-card">
          <h2>Access controls</h2>
          <p>
            Sensitive information is restricted to authorised systems and staff.
            Access is logged and used only when required for operations, safety,
            or compliance purposes.
          </p>
        </section>
      </div>

      <div className="legal-footnote">
        This Privacy Policy is written in plain language for clarity.
        If we update how personal data is handled, the latest version will
        always be published on this page.
      </div>
    </div>
  );
};

export default Privacy;
